// @format

import 'jquery'
import 'jquery-drawer'
import 'jquery-drawer/dist/css/drawer.css';
import { initNotes } from "./notes";
import { initSummernote } from "./summernote";
import { updateCompanyBlockData, updateCompanyBlockCounts, notifyCandidateRowsLoaded } from "./prospect";
import { showNotice } from "./notice";
import { preventDefault } from 'tom-select/dist/cjs/utils';

declare global {
  interface JQuery {
    drawer(): JQuery
  }
}
export function initBotsProspectReplyModal(): void {
  $(document).on("click", ".view-full-data", function () {
    const content = $(this).data("content");
    const title = $(this).data("title");
    const modal = $("#replyModal");
    if (
      title == "Full Current Company" ||
      title == "Full Campaign Name" ||
      title == "Full Reply"
    ) {
      modal.find(`[data-modal-target="content"]`).html(content);
    } else {
      modal.find(`[data-modal-target="content"]`).text(content);
    }
    modal.find(`[data-modal-target="title"]`).text(title);

    modal.modal("show");
  });
}

export function initBotsProspectProfileModal() {
  const $drawer = $('#profile-drawer');
  const $fullProfileDrawer = $('#full-profile-drawer');

  if (!$drawer.length || !$fullProfileDrawer.length) return;

  function openDrawer(drawerId: string, drawerOverlayId: string) {
    $(`#${drawerId}`).addClass('active');
    $(`#${drawerOverlayId}`).addClass('active');
  }

  function closeDrawer(drawerId: string, drawerOverlayId: string) {
    $(`#${drawerId}`).removeClass('active');
    $(`#${drawerOverlayId}`).removeClass('active');
  }

  function populateProfileDrawer(data: any) {
    $drawer.find('#prospectName').text(data.name || '');
    $drawer.find('#prospectLocation').text(data.location || '');
  }

  function populateFullProfileDrawer(data: any) {
    $fullProfileDrawer.find('#prospectName').text(data.name || '');
    if (data.companyDomain !== "N/A") {
      $fullProfileDrawer.find('#prospectCompany').html(`
        <a
          href="https://${data.companyDomain}"
          target="_blank"
          rel="noopener noreferrer"
          class="text-primary"
          style="text-decoration: none;"
        >
          ${data.companyName}
        </a>
      `)
    } else {
      $fullProfileDrawer.find('#prospectCompany').text(data.company || '');
    }

    $fullProfileDrawer.find('#prospectPosition').text(data.position || '');
    $fullProfileDrawer.find('#prospectDomain').text(data.domain || '');
  }

  // $(document).on('click', '.view-full-profile', function() {
  //   try {
  //     const prospect = $(this).closest('td').data('prospect');
  //     populateProfileDrawer(prospect);
  //     openDrawer('profile-drawer', 'profile-drawer-overlay');
  //     $drawer.find('#open-full-drawer-btn').on('click', () => {
  //       try {
  //         const btn = $(this);
  //         const prospect = btn.closest('td').data('prospect');
  //         populateFullProfileDrawer(prospect);
  //         openDrawer('full-profile-drawer', 'full-profile-drawer-overlay');
  //       } catch (err) {
  //         alert("Something went wrong, cannot load data for this candidate");
  //       }
  //     });
  //   } catch (err) {
  //     alert("Something went wrong, cannot load data for this candidate");
  //   }
  // });

  $drawer.find('.drawer-close').on('click', function() {
    closeDrawer('profile-drawer', 'profile-drawer-overlay');
  });

  $('#profile-drawer-overlay').on('click', function() {
    closeDrawer('profile-drawer', 'profile-drawer-overlay');
  });

  $fullProfileDrawer.find('.drawer-close').on('click', function() {
    closeDrawer('full-profile-drawer', 'full-profile-drawer-overlay');
  });

  $('#full-profile-drawer-overlay').on('click', function() {
    closeDrawer('full-profile-drawer', 'full-profile-drawer-overlay');
  });
}

export function initPaginationLimitButtons(): void {
  $(document).ready(function() {
    const $buttons = $('.pagination-limit-btn')
    const activeColor = '#005cd3'

    const initialLimit = parseInt(String($buttons.first().data('initial-limit') ?? 100), 10) || 100

    $buttons.each(function() {
      const $button = $(this)
      const limit = parseInt($button.data('limit'), 10)

      if (limit === initialLimit) {
        $button.css('background-color', activeColor)
        $button.css('color', '#fff')
      } else {
        $button.css('background-color', '')
        $button.css('color', '')
      }
    })

    $buttons.on('click', function() {
      const $clicked = $(this)
      const limit = parseInt($clicked.data('limit'), 10)

      $buttons.css({ 'background-color': '', 'color': '' })
      $clicked.css({ 'background-color': activeColor, 'color': '#fff' })

      const globalWindow = window as typeof window & {
        changePaginationLimit?: (limit: number) => void
      }

      try {
        const wrapper = document.getElementById('candidates-table')
        const isPhoneDashboard = wrapper?.getAttribute('data-phone-dashboard') === 'true'
        if (isPhoneDashboard && Number.isFinite(limit) && limit > 0) {
          window.localStorage.setItem(
            'phone_dashboard_grid_pagination_v1',
            JSON.stringify({ page: 1, perPage: limit })
          )
        }
      } catch {
        // ignore
      }

      if (typeof globalWindow.changePaginationLimit === 'function') {
        globalWindow.changePaginationLimit(limit)
      }
    })
  })
}

export function initRenderGroupedCandidatesByCompany() {
	$("#companies-group .company-group.toggle").off("click").on("click", function () {
		if ($(this).hasClass("collapsed")) {
			const $ele = $(this).next().find('.render-grouped-prospects')
      const $companyBlock = $ele.closest('.company-block');
      const url =  $ele.data('url')

      $.get(url, function(data) {
				$ele.html(data['partial'])
        reInitBotsProspectsJs();
        if($("#companies-group").data("tab") == "rejected") {
          updateCompanyBlockCounts($companyBlock, data['counts']);
        } else {
          updateCompanyBlockData($companyBlock, data['counts']);
        }
        notifyCandidateRowsLoaded();
			});
		}
	});
}

function reInitBotsProspectsJs() {
   $('[data-toggle="popover"]').popover({ html: true, sanitize: false, trigger: 'click' });
  initNotes();
  initNoteBtns();
  initSummernote();
}

function initNoteBtns() {
  $('.notes-button').off('click').on('click', function() {
    const botsProspectId = $(this).data('bots-prospect-id');
    const $noteContainer = $(`.notes-${botsProspectId}`);

    if ($noteContainer.children().length === 0) {
      const url = $noteContainer.data('url');

      $.get(url, function(data) {
        $noteContainer.html(data);
        initSummernote();
      });
    }
  });
}

let globalPollingInterval: NodeJS.Timeout | null = null;

export function initCandidatesDataProcessingStatusCheck() {  
  if (globalPollingInterval) {
    clearInterval(globalPollingInterval);
    globalPollingInterval = null;
  }
  
  const $loadingAlert = $('.candidates-loading-alert');
  
  if (!$loadingAlert.length) return;
  
  const botId = $loadingAlert.data('bot-id');

  if (!botId) return;
  
  function checkStatus() {
    console.log("checking candidate import status");

    $.get('/bots_prospects/check_candidates_enqueue_status', { bot_id: botId })
      .done(function(data) {
        if (data.completed) {
          window.location.reload();
          
          if (globalPollingInterval) {
            clearInterval(globalPollingInterval);
            globalPollingInterval = null;
          }
        }
      })
      .fail(function() {
        console.error('Failed to check data processing status');
      });
  }
  
  globalPollingInterval = setInterval(checkStatus, 5000);
  checkStatus();
}

// All Candidates "Export CSV": enqueue the background export, then poll until the
// CSV has been built + uploaded and trigger the browser download. Delegated + bound
// once (module-level guard) so it survives Turbo navigations without double-binding.
let exportCandidatesCsvBound = false;

function pollForExportedCsv(
  token: string,
  statusUrl: string,
  downloadUrl: string,
  reset: () => void
): void {
  const MAX_ATTEMPTS = 150; // ~5 minutes at 2s between polls
  let attempts = 0;

  const tick = (): void => {
    attempts += 1;
    if (attempts > MAX_ATTEMPTS) {
      showNotice('The CSV is taking longer than expected. Please try again shortly.', 'danger');
      reset();
      return;
    }

    fetch(`${statusUrl}?token=${encodeURIComponent(token)}`, { headers: { Accept: 'application/json' } })
      .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
      .then((data: { ready?: boolean }) => {
        if (data.ready) {
          // send_data sets Content-Disposition: attachment, so this downloads
          // without navigating away from the candidates page.
          window.location.href = `${downloadUrl}?token=${encodeURIComponent(token)}`;
          reset();
        } else {
          setTimeout(tick, 2000);
        }
      })
      .catch(() => setTimeout(tick, 2000));
  };

  setTimeout(tick, 1500);
}

export function initExportCandidatesCsv(): void {
  if (exportCandidatesCsvBound) return;
  exportCandidatesCsvBound = true;

  $(document).on('click', '#export-csv-btn', function () {
    const $btn = $(this);
    if ($btn.hasClass('is-exporting')) return;

    const exportUrl = $btn.attr('data-export-url') || '';
    const statusUrl = $btn.attr('data-status-url') || '';
    const downloadUrl = $btn.attr('data-download-url') || '';
    if (!exportUrl || !statusUrl || !downloadUrl) return;

    const $label = $btn.find('.export-csv-label');
    const originalLabel = $label.text();
    const csrf = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null)?.content || '';

    const reset = (): void => {
      $btn.removeClass('is-exporting').prop('disabled', false);
      $label.text(originalLabel);
    };

    $btn.addClass('is-exporting').prop('disabled', true);
    $label.text('Preparing…');

    fetch(exportUrl, {
      method: 'POST',
      headers: { 'X-CSRF-Token': csrf, Accept: 'application/json' },
    })
      .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
      .then((data: { token?: string }) => {
        if (!data.token) return Promise.reject('no token');
        pollForExportedCsv(data.token, statusUrl, downloadUrl, reset);
      })
      .catch(() => {
        showNotice('Could not start the CSV export. Please try again.', 'danger');
        reset();
      });
  });
}

export function initAIReviewStatusCheck() {
  $(document).off('click', '.rerun-ai-review-btn').on('click', '.rerun-ai-review-btn', function() {
    const botProspectId = $(this).data('bot-prospect-id');
    if (botProspectId) {
      const intervalId = setInterval(function() {
        $.get(`/bots_prospects/${botProspectId}/check_prospect_in_review`)
          .done(function(data) {
            if (!data.in_review) {
              clearInterval(intervalId);
              const $tab = $(`.show-prospect-ai-review-tab[data-bot-prospect-id="${botProspectId}"]`);
              if ($tab.length) {
                $tab.trigger('click');
              }
            }
          })
          .fail(function() {
            console.error('Failed to check AI review status');
            clearInterval(intervalId);
          });
      }, 5000);
    }
  });
}